export default {
  'profile.verified': 'Verificado',
  'profile.unverified': 'No verificado',
  'profile.refresh': 'Actualizar',
  'profile.name': 'Nombre',
  'profile.getCode': 'Obtener código',
  'profile.codeTip': 'Introduzca el código',
  'profile.verifyCode': 'Código de verificación',
  'profile.phoneChange': 'Cambiar el número de teléfono',
  'profile.checkPhone': 'Verificar teléfono actual',
  'profile.bindNewPhone': 'Vincular nuevo teléfono',
  'profile.nuxt': 'Continuar',
  'profile.changeSuccess': '¡Cambio realizado!',
  'profile.firstNameTip': 'Introduzca el nombre',
  'profile.lastNameTip': 'Introduzca el apellido',
  'profile.emailChange': 'Cambiar correo electrónico',
  'profile.checkEmail': 'Verificar correo electrónico actual',
  'profile.bindNewEmail': 'Vincular nuevo correo electrónico',
  'profile.bindEmailTip': 'Ej: usuario@dominio.es',
  'app.profile': 'Centro personal',
  'app.profile.account': 'Configuración de cuenta',
  'app.profile.account.save': 'Guardar cambios',
  'app.profile.account.account': 'Cuenta',
  'app.profile.account.password': 'Contraseña',
  'app.profile.account.password.update': 'Última actualización',
  'app.profile.account.password.reset': 'Restablecer contraseña',
  'app.profile.account.name.first': 'Nombre',
  'app.profile.account.name.last': 'Apellido',
  'app.profile.account.name.phone': 'Teléfono móvil',
  'app.profile.account.name.phone.tip':
    'Utilizaremos este número de teléfono para enviarle mensajes sobre eventos de seguridad, facturas y alertas comerciales.',
  'app.profile.account.name.url': 'URL de callback',
  'app.profile.account.name.urlTip':
    'Debe empezar por http:// o https://, no se admiten puertos personalizados y no se admiten segmentos de red privados con direcciones IP de 10.0.0.0/8, 172.16.0.0/12 y 192.168.0.0/16.',
  'app.profile.account.name.verification': 'Estado',
  'app.profile.account.name.verification.tip[1]': 'Válido',
  'app.profile.account.name.verification.tip[2]': 'Inválido',
  'app.profile.developer': 'Configuración para desarrolladores',
  'app.profile.developer.remark': 'Uso exclusivo para integración API',
  'app.profile.developer.label[1]': 'Clave de desarrollador (DevKey)',
  'app.profile.developer.label[2]': 'Secreto API (DevSecret)',
  'app.profile.developer.copy': 'Ver y copiar',
  'app.profile.developer.reset': 'Regenerar secreto',
  'app.profile.developer.reset.tip': 'Observaciones', //new added
  'app.profile.developer.reset.tip.content':
    'Los cambios en el Dev Secret afectarán al push de la API, lo que obligará a cambiar el código de llamada.', //new added
  'app.profile.developer.reset.tip.sure': 'Confirmar', //new added
  'app.profile.developer.reset.tip.cancel': 'Más tarde ', //new added
  'app.profile.developer.copy.success': '¡Copiado correctamente!',
  'app.profile.developer.reset.success': 'Reiniciado con éxito',
  'app.profile.single': 'SSO (Single Sign-On)',
  'app.profile.single.tip[1]': 'Mejora la seguridad y reduce el riesgo de cuenta',
  'app.profile.single.tip[2]':
    'Evita la creación frecuente de cuentas cuando los empleados utilizan sistemas empresariales diferentes',
  'app.profile.single.tip[3]':
    'Simplifica la autenticación mediante un sistema interno de cuentas de empleados',
  'app.profile.single.enable': 'Contacto',
  'app.profile.single.title': 'Solicitar activación SSO',
  'app.profile.single.subject': 'Asunto',
  'app.profile.single.subject.value': 'Activar el inicio de sesión único para mi cuenta',
  'app.profile.single.content':
    'Solicito la configuración de inicio de sesión único para nuestra empresa.',
  'app.profile.single.subject.validator': 'Introduzca el asunto',
  'app.profile.single.subject.doc': 'Activar el inicio de sesión único para mi cuenta',
  'app.profile.single.message': 'Mensaje',
  'app.profile.single.message.validator': 'Introduzca su mensaje',
  'app.profile.single.submit': 'Enviar',
  'app.profile.single.submit.success': `Enviado con éxito, a la espera de la respuesta por correo electrónico del administrador`,
  'app.profile.account.deletion': 'Eliminar mi cuenta',
  'app.profile.account.deletion.warn':
    'Cuando elimine su cuenta, su cuenta con su información de usuario, información comercial, información de pedidos y otros datos asociados se eliminarán de forma permanente. Una vez eliminada su cuenta, no podrá recuperar su cuenta ni sus datos.',
  'app.profile.account.deletion.action': 'Eliminar mi cuenta',
  'app.profile.delete.title': 'Eliminar cuenta',
  'app.profile.delete.content':
    '¡Atención! La eliminación de su cuenta es irreversible. Eliminará permanentemente datos e información como usuarios, empresas, saldos, facturas, pedidos e intereses de esta cuenta, y todos los servicios relacionados se darán por terminados.',
  'app.profile.delete.content2':
    'Tal vez pueda lograr su objetivo «modificando la dirección de correo electrónico de la cuenta» o «concediendo permisos de función a los miembros de la organización». Se recomienda intentar seguir utilizando la cuenta a menos que sea absolutamente necesario.',
  'app.profile.delete.warn': '¡No se podrá eliminar su cuenta cuando hay que pagar un suplemento!',
  'app.profile.delete.cancel': 'Cancelar',
  'app.profile.delete.next': 'Siguiente',
  'app.profile.delete.delete': 'Eliminar',
  'app.profile.delete.confirm': 'Confirmar eliminación',
  'app.profile.delete.confirm.content':
    'Para confirmar la eliminación:1. Revise su correo electrónico 2. Introduzca el código de verificación enviado',
  'app.profile.delete.confirm.send': 'Enviar código de verificación',
  'app.profile.delete.confirm.send.resend': 'Reenviar código de verificación',
  'app.profile.delete.confirm.resend': 'Reenviar',
  'app.profile.delete.confirm.rule': 'Por favor, introduzca la verificación correcta',
  'app.profile.delete.confirm.code.title': 'Código de verificación de correo',
  'app.profile.delete.confirm.code.desc':
    'Para verificar su identidad y garantizar la seguridad de la cuenta, introduzca el código de verificación recibido en su correo electrónico currentAccount.email',
  'app.profile.delete.confirm.reason.title': 'Razones de eliminación',
  'app.profile.delete.confirm.reason.desc':
    'Esta información nos ayuda a mejorar nuestros productos',
  'app.profile.delete.confirm.reason.placeholder': 'Seleccionar razones',
  'app.profile.delete.confirm.reason.select1': 'Eliminar una cuenta de prueba',
  'app.profile.delete.confirm.reason.select2': 'Cambiar de cuenta',
  'app.profile.delete.confirm.reason.select3':
    'Ya no está interesado en utilizar los servicios de EngageLab',
  'app.profile.delete.confirm.reason.select4': 'Otros',
  'app.profile.reset.title': 'Restablecer contraseña',
  'app.profile.reset.password.old': 'Contraseña actual',
  'app.profile.reset.password.old.placeholder': 'Por favor, introduzca la contraseña antigua',
  'app.profile.reset.password.new': 'Nueva ontraseña',
  'app.profile.reset.password.new.placeholder': 'Introduzca una nueva contraseña',
  'app.profile.reset.password.confirm': 'Confirmar contraseña',
  'app.profile.reset.password.confirm.placeholder': 'Confirme su contraseña',
  'app.profile.reset.cancel': 'Cancelar',
  'app.profile.reset.confirm': 'Confirmar',
  'app.profile.rule.blank': 'Este campo es obligatorio',
  'app.profile.reset.new.rule[0]': 'Combinación de letras y números, al menos 8 caracteres',
  'app.profile.reset.new.rule[1]': 'Hay que contener mayúsculas y minúsculas al mismo tiempo',
  'app.profile.reset.new.rule[2]': 'Debe contener al menos un número (0-9) o un símbolo',
  'app.profile.reset.confrim.rule[0]': 'Las contraseñas no coinciden',
  'app.profile.reset.old.rule[0]': 'Contraseñas inconsistentes',
  'app.profile.reset.success': 'Contraseña actualizada!',
  'app.profile.aws.title': 'Pedidos de Amazon',
  'app.profile.aws.subtitle':
    'Su cuenta de EngageLab está vinculada a su cuenta de Amazon. Vincule sus pedidos de Amazon a los servicios de EngageLab aquí para disfrutar de ventajas VIP.',
  'app.profile.aws.account': 'Número de cuenta de Amazon:',
  'app.profile.aws.btn': 'Gestión de pedidos',
  'app.profile.human.code.loadingTip': 'Por favor, espere…',
  'app.profile.human.code.placeholder': 'Ingrese el código de verificación',
  'app.profile.human.check.tip': 'Por favor, complete primero la verificación de ser humano.',
  'app.profile.human.check.error':
    'La verificación de ser humano ha fallado, por favor, inténtelo de nuevo.',
  'app.profile.sso.title': 'Servicio de Configuración SSO',
  // SSO Empty
  'app.profile.sso.empty.title': 'No ha configurado ningún SSO',
  'app.profile.sso.empty.description':
    'Después de configurar SSO, los usuarios, miembros y socios comerciales bajo la organización configurada pueden acceder de forma segura a todo lo que necesitan para hacer su mejor trabajo, así como a una experiencia de inicio de sesión intuitiva.',
  'app.profile.sso.empty.configure': 'Configurar SSO',
  'app.profile.sso.empty.title2': 'No hay beneficios SSO',
  'app.profile.sso.empty.description2':
    'Su organización no ha abierto los beneficios SSO. Por favor, contacte con el negocio para abrir los beneficios antes de configurar.',
  'app.profile.sso.empty.contact': 'Contactar',
  'app.profile.sso.empty.contact.content': 'Quiero crear SSO',
  // SSO List
  'app.profile.sso.list.configure': 'Configurar SSO',
  'app.profile.sso.list.authorizedOrg': 'Organización Autorizada',
  'app.profile.sso.list.benefitStatus': 'Estado de Beneficios',
  'app.profile.sso.list.authorizedOrgLong':
    'Organización Autorizada Organización Autorizada Organización Autorizada Organización Autorizada Organización Autorizada Organización Autorizada Organización Autorizada',
  'app.profile.sso.list.edit': 'Editar',
  'app.profile.sso.list.authorize': 'Autorizar',
  'app.profile.sso.list.delete': 'Eliminar',
  'app.profile.sso.list.deleteConfirm.title': '¿Confirmar eliminar servicio SSO {name}?',
  'app.profile.sso.list.deleteConfirm.content':
    'Después de eliminar el servicio SSO, las organizaciones autorizadas por este servicio ya no admitirán el inicio de sesión SSO, el enlace de inicio de sesión será inválido y recibirán un correo electrónico para dejar de usar el inicio de sesión SSO.',
  'app.profile.sso.list.deleteSuccess': 'Eliminado correctamente',
  'app.profile.sso.list.confirm.modify.title':
    '¿Confirmar modificar la autorización de servicio SSO?',
  'app.profile.sso.list.confirm.modify.content.add':
    'Las organizaciones autorizadas nuevas recibirán un correo electrónico de recordatorio que incluye el enlace de inicio de sesión SSO para que puedan iniciar sesión.',
  'app.profile.sso.list.confirm.modify.content.remove':
    'Las organizaciones autorizadas eliminadas recibirán un correo electrónico de recordatorio que incluye los enlaces de inicio de sesión alternativos para que puedan iniciar sesión.',
  // SSO Option
  'app.profile.sso.option.step1': 'Configuración IdP',
  'app.profile.sso.option.step2': 'Retorno de Fuente de Datos',
  'app.profile.sso.option.step3': 'Autorizar Organización',
  'app.profile.sso.option.step4': 'Verificación',
  'app.profile.sso.option.continue': 'Continuar',
  'app.profile.sso.option.prev': 'Atrás',
  'app.profile.sso.option.back': 'Volver',
  'app.profile.sso.option.submit': 'Enviar',
  'app.profile.sso.option.save': 'Guardar y verificar',
  // SSO Step 1
  'app.profile.sso.step1.title': 'Configurar Engagelab en IdP',
  'app.profile.sso.step1.description':
    'Inicio de Sesión Único (SSO), primero necesita agregar Engagelab como una aplicación en su Proveedor de Identidad (IdP). Por favor contacte al administrador de IdP de su organización para agregar la configuración de la aplicación bajo su cuenta.',
  'app.profile.sso.step1.serviceType': 'Tipo de Servicio SSO',
  'app.profile.sso.step1.guideText':
    'Puede usar el siguiente token para colaborar con el administrador de IdP de su organización:',
  'app.profile.sso.step1.copy': 'Copiar',
  'app.profile.sso.step1.confirmTip':
    'Confirmo que la información de la aplicación Engagelab ha sido actualizada en su IdP',
  'app.profile.sso.step1.infoText': `I am setting up SSO for Engagelab, and I need assistance setting up Engagelab as an application in our identity provider.

Here is the information that Engagelab provides for setting up the application:

Entity ID:643e77b90116033eef7e325b001
ACS URL: https://www.engagelab.com/accounts/signin/callback?connection=643e77b90116033eef7e325b001
Login URL：https://www.engagelab.com/accounts/signin-sso
Logout URL：https://www.engagelab.com/api/console/account/login/out

Once the Engagelab application is set up in our IdP, please send me the following information from the IdP to complete SSO setup in Engagelab:

X.509 certificate:`,
  // SSO Step 2
  'app.profile.sso.step2.title': 'Ingresar Datos de Retorno IdP',
  'app.profile.sso.step2.description':
    'Ahora que ha configurado la aplicación Engagelab en su Proveedor de Identidad y tiene la información necesaria, por favor ingrese la siguiente información de la aplicación IdP aquí.',
  'app.profile.sso.step2.serviceName': 'Nombre del Servicio SSO',
  'app.profile.sso.step2.serviceNamePlaceholder':
    'Por favor ingrese un nombre que describa el servicio SSO para fácil distinción en la lista de servicios',
  'app.profile.sso.step2.certificate': 'Certificado x509',
  'app.profile.sso.step2.certificatePlaceholder':
    'Por favor copie el contenido del certificado base64 aquí',
  'app.profile.sso.step2.loginUrl': 'URL de Inicio de Sesión IdP',
  'app.profile.sso.step2.loginUrlPlaceholder':
    'Por favor ingrese la URL de inicio de sesión del Proveedor de Identidad',
  'app.profile.sso.step2.logoutUrl': 'URL de Cierre de Sesión IdP',
  'app.profile.sso.step2.logoutUrlPlaceholder':
    'Por favor ingrese la URL de cierre de sesión del Proveedor de Identidad',
  // SSO Step 3
  'app.profile.sso.step3.title': 'Autorizar IdP a Organización',
  'app.profile.sso.step3.description':
    'Por favor autorice este servicio SSO a las organizaciones que ha creado. Los miembros de la organización pueden iniciar sesión en Engagelab usando el Proveedor de Identidad (IdP) configurado.',
  'app.profile.sso.step3.selectOrg': 'Seleccionar Organización',
  'app.profile.sso.step3.contactBusiness': 'Contactar Negocios',
  'app.profile.sso.step3.noBenefitTip':
    'La organización actual no tiene beneficios y no está disponible',
  'app.profile.sso.step3.saveConfirm.title':
    'Después de configurar el servicio SSO para la organización, los miembros de la organización deben usar el inicio de sesión SSO para acceder a la organización',
  'app.profile.sso.step3.saveConfirm.content':
    'Después de guardar, todos los miembros de la organización serán desconectados y recibirán un correo electrónico que requiere inicio de sesión SSO',
  'app.profile.sso.step3.canAuthorize': 'Autorizable',
  'app.profile.sso.step3.numLimit.title': 'Restringido',
  'app.profile.sso.step3.numLimit.tip': 'Límite de protocolo SSO excedido',
  'app.profile.sso.step3.numLimit.text': 'Límite de protocolo SSO excedido, no disponible',
  'app.profile.sso.step3.noBenefit.title': 'Sin derechos',
  'app.profile.sso.step3.noBenefit.text':
    'La organización actual no tiene beneficios, no disponible',
  'app.profile.sso.step3.column.orgId': 'ID de Organización',
  'app.profile.sso.step3.column.orgName': 'Nombre de Organización',
  'app.profile.sso.step3.column.memberNum': 'Número de Miembros',
  'app.profile.sso.step3.column.authStatus': 'Estado de Autorización',
  'app.profile.sso.step3.column.timeZone': 'Zona Horaria',
  'app.profile.sso.step3.column.createTime': 'Tiempo de Creación',
  // SSO Step 4
  'app.profile.sso.step4.title': 'Verificar Servicio SSO',
  'app.profile.sso.step4.description':
    'Ahora que ha completado todas las configuraciones SSO, por favor confirme finalmente que los usuarios pueden iniciar sesión exitosamente en Engagelab usando SSO.',
  'app.profile.sso.step4.loginUrl': 'URL de Inicio de Sesión SSO',
  'app.profile.sso.step4.tip': 'Consejo',
  'app.profile.sso.step4.tipContent':
    'Las cuentas que inician sesión a través de este enlace automáticamente recibirán el rol Default si no tienen ningún rol en la organización. Puede modificar su rol después de que los miembros se unan.',
  'app.profile.sso.step4.notice': 'Por Favor Note',
  'app.profile.sso.step4.noticeContent':
    'Las cuentas que inician sesión a través de este enlace automáticamente recibirán el rol Default si no tienen ningún rol en la organización. Puede modificar su rol después de que los miembros se unan.',
  'app.profile.sso.step4.needHelp': '¿Aún necesita ayuda',
  'app.profile.sso.step4.helpContent':
    '¿No puede iniciar sesión exitosamente? Por favor consulte la documentación para la inspección.',
  'app.profile.sso.step4.viewDoc': 'Ver Documentación',
  // SSO Details
  'app.profile.sso.details.title': 'Detalles del Servicio SSO',
  'app.profile.sso.details.serviceDetails': 'Detalles del Servicio SSO',
  'app.profile.sso.details.name': 'Nombre',
  'app.profile.sso.details.namePlaceholder': 'Por favor ingrese nombre',
  'app.profile.sso.details.type': 'Tipo',
  'app.profile.sso.details.typePlaceholder': 'Por favor ingrese tipo',
  'app.profile.sso.details.loginLink': 'Enlace de Inicio de Sesión SSO',
  'app.profile.sso.details.loginLinkPlaceholder':
    'Por favor ingrese enlace de inicio de sesión SSO',
  'app.profile.sso.details.spConfig': 'Información de Configuración SP',
  'app.profile.sso.details.entityIdPlaceholder': 'Por favor ingrese Entity ID',
  'app.profile.sso.details.idpConfig': 'Información de Configuración IDP',
  'app.profile.sso.details.certificatePlaceholder': 'Por favor ingrese certificado X.509',
  'app.profile.sso.details.loginUrlPlaceholder': 'Por favor ingrese Login URL',
  'app.profile.sso.details.logoutUrlPlaceholder': 'Por favor ingrese Logout URL',
  'app.profile.sso.details.urlPlaceholder': 'Por favor ingrese URL correcta',
  'app.profile.sso.details.certificateExpiry': 'El certificado expirará el {date}',
  'app.profile.sso.details.cancel': 'Cancelar',
  'app.profile.sso.details.save': 'Guardar',
  'app.profile.sso.details.edit': 'Editar',
  // SSO OrgSelect
  'app.profile.sso.orgSelect.title': 'Autorizar Organización',
  'app.profile.sso.orgSelect.availableOrg': 'Organizaciones Disponibles',
  'app.profile.sso.orgSelect.serviceExpired': 'Beneficios del servicio expirados, no disponible',
  'app.profile.sso.orgSelect.contactBusiness': 'Contactar Negocios',
  'app.profile.sso.orgSelect.authorizedService': 'Servicio Autorizado',
  'app.profile.sso.orgSelect.serviceNameLong':
    'Nombre del servicio SSO nombre del servicio nombre del servicio nombre del servicio SSO nombre del servicio nombre del servicio nombre del servicio nombre del servicio SSO nombre del servicio nombre del servicio nombre del servicio nombre del servicio SSO nombre del servicio nombre del servicio nombre del servicio nombre del servicio',
  'app.profile.sso.orgSelect.selectedOrg': 'Organizaciones Seleccionadas',
  'app.profile.sso.orgSelect.noSelectedOrg':
    'No hay organizaciones seleccionadas, por favor seleccione desde la izquierda',
  'app.profile.sso.orgSelect.noAvailable': 'No hay organizaciones disponibles',
  'app.profile.sso.orgSelect.authorized': 'Autorizado',
  'app.profile.sso.orgSelect.cancel': 'Cancelar',
  'app.profile.sso.orgSelect.save': 'Guardar',
  'app.profile.sso.orgSelect.canAuthorize': 'Puede Autorizar',
  'app.profile.sso.orgSelect.otherAuthorize': 'Otra Autorización',
  'app.profile.sso.orgSelect.noBenefit': 'Sin Beneficios',
  'app.profile.sso.orgSelect.saveSuccess': 'Guardar Exitoso',
  'app.profile.sso.list.ssoServiceName': 'Nombre del Servicio SSO',
  'app.profile.sso.list.ssoType': 'Tipo',
  'app.profile.sso.list.ssoLoginUrl': 'Enlace de Inicio de Sesión SSO',
  'app.profile.sso.list.authOrgList': 'Organizaciones Autorizadas',
  'app.profile.sso.authorized.organizations': 'Organizaciones Autorizadas',
  'app.profile.sso.benefit.status': 'Estado de Beneficios',
  'app.sso.no.permission.title': 'Sin Permiso',
  'app.sso.no.permission.desc': 'Por favor, contacte con el administrador para obtener permiso',
  'app.sso.no.permission.logout': 'Cerrar sesión',
};
